import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { inventoryLogActions } from "../slices/inventoryLog";
import { getErrorMessage } from "../../utils/errorUtils";
import { InventoryLogResponseDto } from "../../shared/dtos/inventory/InventoryLogResponseDto";
import { PaginationQueryDto } from "../../shared/dtos/common/PaginationQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getInventoryLogs =
  (params?: PaginationQueryDto) => async (dispatch: AppDispatch) => {
    dispatch(inventoryLogActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<InventoryLogResponseDto>>
      >("/inventory-logs", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(inventoryLogActions.setItems(data.data.content));
        dispatch(inventoryLogActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(inventoryLogActions.setError(getErrorMessage(error)));
    }
  };
